(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ba-compact-menu"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('ba-compact-menu')) return;
  class BACompactMenu extends HTMLElement {
    connectedCallback() {
      if (this.abort || typeof HTMLDialogElement === 'undefined') return;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) {
        if (!this.childObserver) {
          this.childObserver = new MutationObserver(() => {
            if (!this.querySelector('dialog')) return;
            this.childObserver.disconnect(); this.childObserver = null;
            if (this.isConnected) this.connectedCallback();
          });
          this.childObserver.observe(this, {childList: true});
        }
        return;
      }
      if (typeof this.dialog.showModal !== 'function') return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.isEditor = this.dataset.editor === 'true';
      this.oldTrigger = null;
      this.lock = null;
      this.keyboardInput = false;
      document.addEventListener('pointerdown', () => {
        this.keyboardInput = false;
        this.dialog.dataset.baKeyboard = 'false';
      }, {capture: true, signal});
      document.addEventListener('keydown', (event) => {
        if (!['Tab', 'Enter', ' ', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        this.keyboardInput = true;
        this.dialog.dataset.baKeyboard = 'true';
      }, {capture: true, signal});
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest && event.target.closest('#maison-drawer-trigger');
        if (!trigger) return;
        event.preventDefault(); event.stopImmediatePropagation();
        this.open(trigger, event.detail === 0);
      }, {capture: true, signal});
      document.addEventListener('maison:openDrawer', (event) => {
        event.stopImmediatePropagation();
        this.open(document.getElementById('maison-drawer-trigger'), this.keyboardInput);
      }, {capture: true, signal});
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-ba-close]')) this.close();
        else if (event.target === this.dialog) {
          const r = this.dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.close();
        }
      }, {signal});
      this.dialog.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') return;
        const items = [...this.dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter(el => el.getClientRects().length);
        const first = items[0], last = items[items.length - 1];
        if (!first) return;
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }, {signal});
      this.dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.close(); }, {signal});
      this.dialog.addEventListener('close', () => this.release(), {signal});
      this.addEventListener('change', (event) => {
        if (!event.target.matches('[data-ba-locale]') || !event.target.form) return;
        const field = event.target.closest('.ba-menu__locale-field');
        const option = event.target.selectedOptions[0];
        if (field && option) {
          const label = field.querySelector('[data-ba-locale-text]');
          const flag = field.querySelector('.ba-locale-flag');
          if (label) label.textContent = option.dataset.label || option.textContent.trim();
          if (flag) {
            flag.hidden = !option.dataset.flag;
            if (option.dataset.flag) flag.src = option.dataset.flag;
          }
        }
        if (typeof event.target.form.requestSubmit === 'function') event.target.form.requestSubmit();
        else event.target.form.submit();
      }, {signal});
      window.addEventListener('resize', () => this.position(), {signal});
      window.addEventListener('pagehide', () => this.close(false, true), {signal});
      document.addEventListener('shopify:section:select', (event) => {
        if (event.detail && event.detail.sectionId === this.dataset.sectionId) this.open();
      }, {signal});
      document.addEventListener('shopify:block:select', (event) => {
        if (!this.contains(event.target)) return;
        this.open(); event.target.scrollIntoView({block: 'nearest', inline: 'nearest'});
      }, {signal});
      const start = () => {
        if (!this.isConnected) return;
        const remembered = this.isEditor && window.__baMenuEditorOpen === this.dataset.sectionId;
        if (remembered || new URLSearchParams(location.search).get('ba_menu') === '1') {
          this.open();
          const state = window.__baMenuEditorState;
          if (remembered && state && state.id === this.dataset.sectionId) {
            const scroll = this.querySelector('.ba-menu__scroll');
            if (scroll) scroll.scrollTop = state.scrollTop;
          }
        }
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true, signal});
      else requestAnimationFrame(start);
    }
    position() {
      if (this.dialog) this.dialog.style.setProperty('--ba-top', '0px');
    }
    cancelMotion() {
      if (this.motion) this.motion.cancel();
      this.motion = null;
      this.closing = false;
      if (this.dialog) delete this.dialog.dataset.baClosing;
    }
    playMotion(opening) {
      if (typeof this.dialog.animate !== 'function' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return null;
      const frames = opening
        ? [{transform: 'translateY(-24px)', opacity: 0}, {transform: 'translateY(0)', opacity: 1}]
        : [{transform: 'translateY(0)', opacity: 1}, {transform: 'translateY(-18px)', opacity: 0}];
      return this.dialog.animate(frames, {duration: opening ? 220 : 180, easing: opening ? 'cubic-bezier(.22,1,.36,1)' : 'ease-in', fill: 'both'});
    }
    open(trigger, keyboard = false) {
      if (!this.dialog || !this.isConnected) return;
      if (this.closing) this.cancelMotion();
      if (this.dialog.open) return;
      this.cancelMotion();
      document.dispatchEvent(new CustomEvent('maison:closeDrawer'));
      this.trigger = trigger || document.getElementById('maison-drawer-trigger');
      this.returnFocus = document.activeElement;
      if (this.trigger) {
        this.oldTrigger = ['aria-controls','aria-haspopup','aria-expanded'].map(key => [key, this.trigger.getAttribute(key)]);
        this.trigger.setAttribute('aria-controls', this.dialog.id);
        this.trigger.setAttribute('aria-haspopup', 'dialog');
        this.trigger.setAttribute('aria-expanded', 'true');
      }
      this.dialog.dataset.baKeyboard = keyboard ? 'true' : 'false';
      this.position();
      this.dialog.showModal();
      const motion = this.playMotion(true);
      this.motion = motion;
      if (motion) motion.finished.then(() => {
        if (this.motion !== motion) return;
        motion.cancel(); this.motion = null;
      }).catch(() => {});
      this.lock = {body: document.body.style.overflow, root: document.documentElement.style.overflow};
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      if (this.isEditor) window.__baMenuEditorOpen = this.dataset.sectionId;
    }
    release() {
      if (this.dialog && this.dialog.open) return;
      this.cancelMotion();
      if (this.lock) {
        document.body.style.overflow = this.lock.body;
        document.documentElement.style.overflow = this.lock.root;
        this.lock = null;
      }
      if (this.trigger && this.oldTrigger) {
        this.oldTrigger.forEach(([key,value]) => value === null ? this.trigger.removeAttribute(key) : this.trigger.setAttribute(key,value));
        this.trigger.setAttribute('aria-expanded', 'false');
        this.oldTrigger = null;
      }
    }
    close(restoreFocus = true, immediate = false) {
      if (!this.dialog) return;
      if (this.closing && !immediate) return;
      if (this.isEditor) { window.__baMenuEditorOpen = null; window.__baMenuEditorState = null; }
      this.cancelMotion();
      const finish = () => {
        this.cancelMotion();
        if (this.dialog.open) this.dialog.close();
        this.release();
        const target = this.trigger && this.trigger.isConnected ? this.trigger : this.returnFocus;
        if (restoreFocus && target && target.isConnected) target.focus({preventScroll: true});
      };
      if (immediate || !this.dialog.open || !this.isConnected) { finish(); return; }
      this.closing = true;
      this.dialog.dataset.baClosing = 'true';
      const motion = this.playMotion(false);
      this.motion = motion;
      if (!motion) { finish(); return; }
      motion.finished.then(() => { if (this.motion === motion) finish(); }).catch(() => {});
    }
    disconnectedCallback() {
      if (this.childObserver) this.childObserver.disconnect();
      this.childObserver = null;
      const reopen = this.isEditor && this.dialog && this.dialog.open;
      const scroll = this.querySelector('.ba-menu__scroll');
      const scrollTop = scroll ? scroll.scrollTop : 0;
      this.close(false, true);
      if (reopen) {
        window.__baMenuEditorOpen = this.dataset.sectionId;
        window.__baMenuEditorState = {id: this.dataset.sectionId, scrollTop};
      }
      if (this.abort) this.abort.abort();
      this.abort = null;
    }
  }
  customElements.define('ba-compact-menu', BACompactMenu);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.isTransparent = document.querySelector('.header-wrapper').classList.contains('transparent-header');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.isTransparent) {
        if (scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          this.header.classList.remove('transparent-header');
          if (scrollTop > this.currentScrollTop) {
            this.header.classList.add('shopify-section-header-hidden');
          } else {
            this.header.classList.remove('shopify-section-header-hidden');
          }
        } else {
          this.header.classList.remove('scrolled-past-header', 'shopify-section-header-hidden');
          this.header.classList.add('transparent-header');
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close()); 
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class luminLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lumin-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', luminLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    

class VideoGallery extends HTMLElement {
  constructor() {
    super();
    this.deferredMedia = this.querySelector(".video-gallery__media");
    this.videoPlaylist = this.querySelector(".video-gallery__thumbnails");
    this.activeVideoTitle = this.querySelector(".video-gallery__active-video-title");
    this.videoPlayer = null;

    this.handleVideoClick = this.handleVideoClick.bind(this);
  }

  connectedCallback() {
    this.videoPlaylist.addEventListener("click", this.handleVideoClick);
  }

  disconnectedCallback() {
    this.videoPlaylist.removeEventListener("click", this.handleVideoClick);
  }

  getVideoEmbedRef = () => {
    return document.querySelector('.video-gallery__embed');
  }

  getVideoPlayerRef = () => {
    return document.querySelector('.video-gallery__player');
  }

  clearExistingMedia = (type) => {
    
    const existingEmbed = this.getVideoEmbedRef();
    const existingPlayer = this.getVideoPlayerRef();

    if (type === 'video' && existingEmbed) {
      existingEmbed.remove();
    }

    if (type === 'embed' && existingPlayer) {
      existingPlayer.remove();
    }
  }

  handleVideoClick = (e) => {

    const thumbnailElement = event.target.closest(".video-gallery__thumbnail");
    if (!thumbnailElement) {
      console.error('Thumbnail element not found');
      return;
    }
    
    if (this.deferredMedia) {
      this.deferredMedia.loadContent(false);
    }

    const videoURL = thumbnailElement.dataset.videoUrl;
    const embedType = thumbnailElement.dataset.embedUrlType;
    const embedID = thumbnailElement.dataset.embedUrlId;
    const videoTitle = thumbnailElement.dataset.videoTitle;
    
    if (videoURL) {
        // Load video
        this.loadVideo(videoURL, videoTitle);
    } else if (embedType && embedID) {
        // Load embed
        this.loadEmbed(embedType, embedID, videoTitle);
    } else {
        console.error('Video URL or embed URL not found');
    }

    this.scrollToVideoPlayer(); 
  }

  // Function to scroll to the video player
  scrollToVideoPlayer = () => {
    if (!this.videoPlayer) {
      console.error('Video player element not found');
      return;
    }

    const videoPlayerPosition = this.videoPlayer.getBoundingClientRect().top + window.scrollY - 150;

    window.scrollTo({
      top: videoPlayerPosition,
      behavior: 'smooth'
    });
  }

  loadVideo = (videoURL, videoTitle) => {

    this.clearExistingMedia('video');

    // Get the video player
    this.videoPlayer = this.getVideoPlayerRef();

    if (!this.videoPlayer) {
      this.videoPlayer = document.createElement('video');
      this.videoPlayer.classList.add('video-gallery__player');
      this.videoPlayer.setAttribute('playsinline', '');
      this.videoPlayer.setAttribute('autoplay', '');
      this.videoPlayer.setAttribute('controls', '');

      this.deferredMedia.appendChild(this.videoPlayer);
    }
    
    // Set video source and title
    this.videoPlayer.src = videoURL;
    this.videoPlayer.load();

    // Play the video
    this.videoPlayer.addEventListener('loadedmetadata', function loadedMetadataHandler() {
      this.videoPlayer.play()
        .then(() => {
          // Remove the event listener after playback starts
          this.videoPlayer.removeEventListener('loadedmetadata', loadedMetadataHandler);
        })
        .catch((error) => {
          console.error('Error playing video:', error);
        });
    }.bind(this));

    // Update the active video title
    this.activeVideoTitle.innerText = videoTitle;
  }

  loadEmbed = (embedType, embedID, videoTitle) => {

    if (embedType !== 'youtube' && embedType !== 'vimeo') {
      console.error('Invalid embed type');
      return;
    }

    this.clearExistingMedia('embed');

    const embedURL = (embedType == 'youtube') ? `https://www.youtube.com/embed/${embedID}?autoplay=1`: `https://player.vimeo.com/video/${videoId}?autoplay=1`;

    let embedElement = this.getVideoEmbedRef();

    if (!embedElement) {
      embedElement = document.createElement('iframe');
      embedElement.classList.add('video-gallery__embed');
      embedElement.setAttribute('allow', 'autoplay; encrypted-media');
      embedElement.setAttribute('allowfullscreen', '');
      this.deferredMedia.appendChild(embedElement);
    }
    
    embedElement.src = embedURL;
    embedElement.setAttribute('title', videoTitle);

    this.videoPlayer = embedElement;

    this.activeVideoTitle.innerText = videoTitle;
  }

}

customElements.define('video-gallery', VideoGallery);


  } catch(e) { console.error(e); }
})();
})();
